"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _fontawesomeFacebookSquare = _interopRequireDefault(require("core.ui-module_site-styling/lib/images/icons/fontawesome-facebook-square.svg"));
var _fontawesomeInstagramSquare = _interopRequireDefault(require("core.ui-module_site-styling/lib/images/icons/fontawesome-instagram-square.svg"));
var _fontawesomeLinkedinSquare = _interopRequireDefault(require("core.ui-module_site-styling/lib/images/icons/fontawesome-linkedin-square.svg"));
var _fontawesomeTwitterSquare = _interopRequireDefault(require("core.ui-module_site-styling/lib/images/icons/fontawesome-twitter-square.svg"));
var _fontawesomeYoutubeSquare = _interopRequireDefault(require("core.ui-module_site-styling/lib/images/icons/fontawesome-youtube-square.svg"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const SocialLinks = () => /*#__PURE__*/_react.default.createElement("div", {
  className: "content has-text-centered my-0"
}, /*#__PURE__*/_react.default.createElement("p", {
  className: "social-connect mb-0"
}, "More Ways to Connect"), /*#__PURE__*/_react.default.createElement("ul", {
  className: "social-list mt-2"
}, /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement("a", {
  href: "https://www.instagram.com/missionsquareretirement/",
  title: "Instagram",
  target: "blank"
}, /*#__PURE__*/_react.default.createElement("img", {
  src: _fontawesomeInstagramSquare.default,
  className: "social-icon grow mx-1",
  alt: "Instagram"
}))), /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement("a", {
  href: "https://www.facebook.com/missionsquareretirement",
  title: "Facebook",
  target: "blank"
}, /*#__PURE__*/_react.default.createElement("img", {
  src: _fontawesomeFacebookSquare.default,
  className: "social-icon grow mx-1",
  alt: "Facebook"
}))), /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement("a", {
  href: "https://www.twitter.com/mission_square",
  title: "Twitter",
  target: "blank"
}, /*#__PURE__*/_react.default.createElement("img", {
  src: _fontawesomeTwitterSquare.default,
  className: "social-icon grow mx-1",
  alt: "Twitter"
}))), /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement("a", {
  href: "https://www.linkedin.com/company/missionsquareretirement/",
  title: "Linkedin",
  target: "blank"
}, /*#__PURE__*/_react.default.createElement("img", {
  src: _fontawesomeLinkedinSquare.default,
  className: "social-icon grow mx-1",
  alt: "Linkedin"
}))), /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement("a", {
  href: "https://www.youtube.com/c/MissionSquareRetirement",
  title: "YouTube",
  target: "blank"
}, /*#__PURE__*/_react.default.createElement("img", {
  src: _fontawesomeYoutubeSquare.default,
  className: "social-icon grow mx-1",
  alt: "Youtube"
})))));
SocialLinks.propTypes = {
  footerItems: _propTypes.default.arrayOf(_propTypes.default.shape({
    name: _propTypes.default.string.isRequired,
    path: _propTypes.default.string.isRequired,
    title: _propTypes.default.string.isRequired
  })),
  footerLinks: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.node), _propTypes.default.node, _propTypes.default.element, _propTypes.default.object])
};
SocialLinks.defaultProps = {
  footerItems: undefined,
  footerLinks: undefined
};
var _default = exports.default = SocialLinks;
//# sourceMappingURL=SocialLinks.js.map